export const CUSTOMER_PROJECT_ROUTES = [
  'reports',
  'quotes',
  'incomes',
  'expenses',
  'groupedExpenses',
  'allExpenses',
  'budget',
  'checkout',
  'addProductsToQuote',
  'firstRound',
  'expensesByGroup',
  'newExpense',
  'newIncome',
  'approvedQuotes',
  'purchaseOrder',
]

export const CUSTOMER_ACCOUNT_ROUTES = [
  'projects',
  'members',
  'billing',
  'WalletForCustomer',
  'allMyQuotes',
  'allMyExpenses',
]

export function isCustomerProjectRoute(routeName) {
  return CUSTOMER_PROJECT_ROUTES.includes(routeName)
}

export function isCustomerAccountRoute(routeName, params = {}) {
  return CUSTOMER_ACCOUNT_ROUTES.includes(routeName)
    || (routeName === 'referrals' && Boolean(params.customerId))
}

export function isAdminInCustomerContext(routeName, params = {}) {
  return isCustomerProjectRoute(routeName) || isCustomerAccountRoute(routeName, params)
}
